import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import DashboardLayout from "src/layout/DashboardLayout";

const RouteComponent = () => {
  return (
    <Suspense fallback={<div className="p-6">Loading...</div>}>
      <Routes>
        {route.map((route, index) => {
          const Component = route.components;
          const Layout = route.layout || React.Fragment;

          return (
            <Route key={index} path={route.path} element={<Layout><Component /></Layout>} />
          );
        })}
      </Routes>
    </Suspense>
  );
};

const route = [
  {
    path: "/",
    components: lazy(() => import("src/auth/signin/Login")),
  },
  {
    path: "network-ip-login",
    components: lazy(() => import("src/auth/signin/NetworkIpLogin")),
  },
  {
    path: "/face-recognition",
    components: lazy(() => import("src/auth/signin/FaceLogin.js")),
  },
  {
    path: "/dashboard",
    components: lazy(() => import("src/views/pages/Dashboard")),
    layout: DashboardLayout,
  },
  {
    path: "/send_money",
    components: lazy(() => import("src/views/pages/SendMoney")),
    layout: DashboardLayout,
  },
  {
    path: "/exchange_money",
    components: lazy(() => import("src/views/pages/ExchangeMoney")),
    layout: DashboardLayout,
  },
  {
    path: "/wire_transfer",
    components: lazy(() => import("src/views/pages/WireTransfer")),
    layout: DashboardLayout,
  },
  {
    path: "/payment_request",
    components: lazy(
      () => import("src/views/pages/payment/NewRequest"),
    ),
    layout: DashboardLayout,
  },
  {
    path: "/all_request",
    components: lazy(
      () => import("src/views/pages/payment/AllRequest"),
    ),
    layout: DashboardLayout,
  },
  {
    path: "/transactions_report",
    components: lazy(() => import("src/views/pages/Transaction")),
    layout: DashboardLayout,
  },
  {
    path: "/profile",
    components: lazy(() => import("src/views/profile/Profile")),
    layout: DashboardLayout,
  },
  {
    path: "/settings",
    components: lazy(() => import("src/views/profile/ProfileSettings")),
    layout: DashboardLayout,
  },
  {
    path: "/no-access",
    components: lazy(() => import("src/views/pages/no-access/NoAccess")),
    layout: DashboardLayout,
  },
];

export default RouteComponent;
